/*@flow*/
import type { Node } from 'react';
import React from 'react';
import Item from './Item';
import AsyncSelect from './AsyncSelect';
import { useApolloClient } from '@apollo/react-hooks';
import getAssetCompanyId from 'lib/getAssetCompanyId';

type PropsT = {
  label: React$Node,
  classNamePrefix?: string,
  className: string,
  loadValues: (any) => Promise<string[]>,
  value: any,
  placeholder: string,
  onChange: (any) => any,
};

export default function AsyncTemplate(locals: PropsT): Node {
  const client = useApolloClient();
  const companyId = getAssetCompanyId();
  return (
    <Item label={locals.label}>
      <AsyncSelect
        classNamePrefix={locals.classNamePrefix}
        className={locals.className}
        loadValues={() => locals.loadValues({ client, companyId })}
        value={locals.value}
        placeholder={locals.placeholder}
        onChange={locals.onChange}
      />
    </Item>
  );
}
